// Optional tasks transcribed from the user-supplied September 30, 2026 screenshots.
// Duplicate screenshots consolidated; truncated URLs deliberately omitted.
export const checklistCatalog = [
  {
    name: 'Initial Visit',
    labels: [
      'Discuss and sign State informed consent',
      'Client registration, medical and pregnancy history completed',
      'Informed disclosure for Midwifery Care',
      'Financial Contract Signed',
      'How to Reach Midwives discussed and Handout Given',
      'Discuss and sign Emergency Care Plan',
      'Fill out "Assertation to Decline Tests Required Within 28 Weeks"',
      'Fill out "Assertation to Decline Ongoing Required Tests"',
      'Fill out "Assertation to Decline Tests for Newborn"',
      'Discuss OB profile testing',
      'Discuss HIV testing',
      'Discuss Hepatitis C testing',
      'Discuss GC/Chlamydia testing',
      'Discuss Urine Culture testing',
      'Discuss Vaginal Culture testing',
      'Discuss Pap Smear testing',
      'Discuss Physical Exam',
      'Discuss Pelvimetry testing',
      'Obtain copy of Insurance Card',
      'Over the counter safe medications list',
    ],
  },
  {
    name: 'Second Visit',
    labels: [
      'Perform Physical Exam',
      'Decision to consent to OB profile testing',
      'Decision to decline OB profile testing',
      'Decision to consent to limited OB profile testing as noted in progress notes',
      'Decision to consent to HIV testing',
      'Decision to decline HIV testing',
      'Decision to consent to Hepatitis C testing',
      'Decision to decline Hepatitis C testing',
      'Decision to consent to GC/Chlamydia testing',
      'Decision to decline GC/Chlamydia testing',
      'Decision to consent to Urine Culture testing',
      'Decision to decline Urine Culture testing',
      'Decision to consent to vaginal culture testing',
      'Decision to decline Vaginal culture testing',
      'Decision to consent to Pelvimetry',
      'Decision to decline Pelvimetry',
      'Decision to decline Pap smear',
      'Decision to consent to Pap smear',
      'Insurance benefits review',
      'Discuss Vitamins',
    ],
  },
  {
    name: '1–11 Weeks',
    labels: [
      'Warning signs in the First Trimester',
      'Review of water intake for the 1st trimester',
      'Review of nutrition for the 1st trimester',
      'Activity and exercise for the 1st trimester',
    ],
  },
  {
    name: '9–27 Weeks',
    labels: [
      'Warning signs in the second trimester',
      'Review of water intake for the 2nd trimester',
      'Review of nutrition for the 2nd trimester',
      'Activity and exercise for the 2nd trimester',
      'Discuss option for Ultrasound for Fetal Survey and Placental Location',
      'Consent to Ultrasound for Fetal Survey and Placental Location',
      'Decline Ultrasound for Fetal Survey and Placental Location',
    ],
  },
  {
    name: '11–22 Weeks',
    labels: [
      'Discuss Maternal Quad screen',
      'Information on Maternal Quad screen',
      'Decision to consent to Maternal Quad Screen',
      'Decision to decline Maternal Quad Screen',
      'Quickening discussed',
      'Quickening confirmed by 22 weeks',
    ],
  },
  {
    name: '20–27 Weeks',
    labels: [
      'Discuss Cord Blood collection',
      'Cord Blood Handout given',
      'Discuss Newborn Hearing screening',
      'Newborn Hearing screening handout given',
      'Metabolic Newborn Screening Discussed',
      'Metabolic Newborn Screening Information Given',
      'Discuss Vitamin K and Vit K deficiency bleeding of the newborn',
      'Information pamphlet on Vitamin K and Vit K deficiency bleeding',
      'Vitamin K Information, Additional information',
      'Newborn Eye Prophylaxis Discussed',
      'Newborn Eye Prophylaxis Information Given',
      'Discuss the need to find a Pediatrician',
      'Additional education resource 1 (title and link needed)',
      'Additional education resource 2 (title and link needed)',
    ],
  },
  {
    name: '22–28 Weeks',
    labels: [
      'Gestational Diabetes Screening Information',
      'Gestational Diabetes Screening Options Discussed',
      'Decision to consent to 1 hour gestational diabetes testing',
      'Decision to consent to fasting and 2 hour postprandial diabetes testing',
      'Decision to decline all diabetes testing',
      'Decision to decline 1 hour gestational diabetes testing',
      'Decision to decline fasting and 2 hour postprandial diabetes testing',
      'Decision to decline random diabetes testing',
      'Hgb/Hct recheck discussed',
      'Decision to consent to Hgb/Hct retest between 26 and 28 weeks',
      'Decision to decline Hgb/Hct retest between 26 and 28 weeks',
      'Supply list and birth kit order form given',
    ],
  },
  {
    name: '25–40 Weeks',
    labels: [
      'Warning signs of premature Labor information',
      'Warning signs of Pre-eclampsia/Eclampsia',
      'Fetal Movement Counts discussed',
      'Fetal Movement Counts Log given',
      'Review of Water intake for the 3rd trimester',
      'Review of Nutrition for the 3rd trimester',
      'Activity and exercise for the 3rd trimester',
      'Prenatal perineal Massage discussed and information given',
    ],
  },
  {
    name: '26–28 Weeks',
    labels: [
      'Random Glucose testing performed',
      '1-hour Glucose Challenge test performed',
      'Fasting and 2-hour postprandial Glucose challenge testing performed',
      'Hgb/Hct recheck performed',
      'Antibody Screen recheck performed',
    ],
  },
  {
    name: '28–36 Weeks',
    labels: [
      'Decision to consent to newborn IM administration of Vitamin K',
      'Decision to decline newborn IM administration of Vitamin K',
      'Decision to consent to Oral administration of Vitamin K',
      'Decision to decline Oral administration of Vitamin K',
      'RX and Physicians order to give IM Vitamin K received',
      'Pediatrician chosen by client',
    ],
  },
  {
    name: '30–33 Weeks',
    labels: ['Appointment made for Home visit'],
  },
  {
    name: '32–35 Weeks',
    labels: [
      'Home visit completed',
      'Strep-B discussion and Information',
      'Decision to consent to GBS testing',
      'Decision to decline GBS testing',
    ],
  },
  {
    name: '35–40 Weeks',
    labels: [
      'Discuss signs of labor and when to call',
      'Precipitous delivery instructions',
      'Help after the baby arrives',
    ],
  },
  {
    name: 'Ongoing Prenatal Discussion Checklist',
    labels: [
      'Kegel exercise discussed',
      'Childbirth Classes',
      'Breastfeeding discussed and information given for resources',
      'Discuss Results of OB profile',
      'Discuss Results of partial OB profile',
      'Discuss Results of HIV test',
      'Discuss Results of Hepatitis C test',
      'Discuss Results of GC/Chlamydia test',
      'Discuss Results of Urine Culture test',
      'Discuss Results of Vaginal Culture test',
    ],
  },
  {
    name: 'Initial Lab Work',
    labels: ['Prenatal Profile Discussed', 'Prenatal Profile Decision', 'Prenatal Profile Results Reviewed'],
  },
  {
    name: 'Rh Negative Blood Type Checklist',
    labels: [
      'Information given about Rh sensitization and options for prevention',
      '1st trimester antibody screen discussed',
      '1st trimester antibody screen decision',
      '2nd trimester antibody screen decision',
      '2nd trimester antibody screen discussed',
      'Antenatal RhoGAM discussed',
      'Antenatal RhoGAM decision',
      'Antenatal RhoGAM given',
      '3rd trimester antibody screen decision',
      '3rd trimester antibody screen discussed',
      'Cord blood collected',
      "Baby's ABO & RH determined",
      'Postpartum antibody screen collected',
      'Postpartum RhoGAM discussed',
      'Postpartum RhoGAM decision',
      'Postpartum RhoGAM given',
    ],
  },
  {
    name: 'Post Dates Checklist',
    labels: [
      'Information about post mature pregnancy given',
      'Risks of post mature pregnancy discussed',
      'Risks of induction discussed',
      'Options for alternatives to induction, including doing nothing, discussed',
      'Options for evaluation of fetal well being discussed',
      'Options for evaluation of fetal well being decision',
      'Options for referral for induction discussed',
      'Options for referral for induction decision',
    ],
  },
  {
    name: 'VBAC Checklist',
    labels: [
      'Information about risks, benefits, and alternatives to VBAC given',
      'Ultrasound for placental location discussed',
      'Ultrasound for placental location decision',
      'Ultrasound for placental location reviewed',
      'The Suture Debate',
      'Making an informed decision to VBAC',
      'What is uterine rupture',
      'Risk of C-Section',
      'Things to think about',
      'ACOG revised guidelines',
      '13 VBAC myths',
    ],
  },
  {
    name: 'Newborn',
    labels: [
      'Decision to Consent to Newborn Eye Prophylaxis',
      'Decision to decline Newborn Eye Prophylaxis',
      'Newborn Eye Prophylaxis administered',
    ],
  },
  {
    name: 'Breech',
    labels: [
      'Fact Sheet',
      'Options for breech presentation',
      'Bottoms Up',
      'The Case For and Against Breech Vaginal delivery',
    ],
  },
];
